<template>
  <div class="home-page">
    <page-head class="page-top"></page-head>
    <div class="page-content">
      <left-bar-single></left-bar-single>
      <div class="right-content">
        <router-view></router-view>
      </div>
    </div>
    <loading></loading>
  </div>
</template>

<script>
  import ChartMap from '@/view/map'
  import LeftBarSingle from '../components/LeftBarSingle'
  import PageHead from '../components/PageHead'
  import SwitchMapBtn from '../components_bit/SwitchMapBtn'
  import Loading from '../components_bit/Loading'
  export default {
    components: {
      LeftBarSingle,
      PageHead,
      switch_map_btn: SwitchMapBtn,
      chart_map: ChartMap,
      loading: Loading
    },
    created () {
      this.$store.dispatch('getCaseList')
      if (this.solutionStatus === 0 && this.$router.history.current.name === 'home_base') {
        this.$router.push({name: 'import'})
      }
    },
    computed: {
      solutionStatus: {
        get () {
          return this.$store.getters.solutionStatus
        }
      },
      path: {
        get () {
          return this.$store.state.route.path
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .home-page {
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .page-content {
      display: flex;
      flex-direction: row;
      flex:1;
      .right-content {
        flex:1;
        display: flex;
        overflow:auto;
        background-color: #efefef;
      }
    }
  }
  .page-top {
    z-index: 4;
  }
  .right-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// single_home.vue?00654f58